import { useEffect, useMemo, useState } from "react";

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

import MKTypography from "components/MKTypography";
import api from "services/api";
import { useTranslation } from "react-i18next";
import SignedDownloadButton from "./SignedDownloadButton";

function MerlinDesc() {
  const { t } = useTranslation();
  const [software, setSoftware] = useState(null);
  const downloads = software?.items || [];

  useEffect(() => {
    api
      .get("/software/merlin/")
      .then((res) => {
        setSoftware(res?.data || null);
      })
      .catch(() => {
        setSoftware(null);
      });
  }, []);

  const downloadGroups = useMemo(() => {
    const originals = downloads.filter((download) => download.variant === "original");
    const koolshareItems = downloads.filter((download) => download.variant === "koolshare");

    return originals.map((original) => {
      const koolshare =
        koolshareItems.find(
          (item) =>
            item.install_notes === original.install_notes &&
            item.supported_models === original.supported_models
        ) || null;

      return {
        key: original.arch,
        original,
        koolshare,
      };
    });
  }, [downloads]);

  return (
    <Card
      sx={{
        p: { xs: 2, md: 3 },
        mx: { xs: 2, lg: 3 },
        mt: 2,
        mb: 2,
        boxShadow: ({ boxShadows: { lg } }) => lg,
      }}
    >
      <MKTypography variant="h5" fontWeight="bold" mb={1}>
        {t("clients.merlin.desc.title")}
      </MKTypography>
      <MKTypography variant="body2" color="text" mb={2}>
        {t("clients.merlin.desc.intro")}
      </MKTypography>
      <Grid container spacing={2}>
        {downloadGroups.map(({ key, original, koolshare }) => (
          <Grid key={key} item xs={12} md={6}>
            <Stack
              spacing={1}
              sx={{
                height: "100%",
                border: "1px solid",
                borderColor: "grey.300",
                borderRadius: 1,
                p: 2,
              }}
            >
              <MKTypography variant="h6" fontWeight="bold">
                {original.channel} - {original.install_notes}
              </MKTypography>
              <MKTypography variant="body2" color="text">
                <strong>{t("clients.merlin.supportedModels")}:</strong> {original.supported_models}
              </MKTypography>
              <Stack direction="row" flexWrap="wrap" gap={1}>
                <SignedDownloadButton
                  variant="gradient"
                  color="info"
                  linkUrl={original.signed_link_url}
                  label={t("clients.merlin.originalFirmware")}
                />
                {koolshare?.signed_link_url ? (
                  <SignedDownloadButton
                    variant="outlined"
                    color="info"
                    linkUrl={koolshare.signed_link_url}
                    label={t("clients.merlin.koolshareFirmware")}
                  />
                ) : null}
              </Stack>
            </Stack>
          </Grid>
        ))}
      </Grid>
    </Card>
  );
}

export default MerlinDesc;
